<template>
    <el-container>
        <el-header height="50px">
            <header-modular :region="'认证培训机构'"/>
        </el-header>
        <el-container>
            <el-aside width="240px">
                <nav-modular :navPath="navPath" class="left-nav"></nav-modular>
            </el-aside>
            <el-main>
                <div class="main-warpper">
                    <page-title :pageTitle="pageTitle" :isBack="isBack"/>
                    <router-view @setIndex="getIndex(arguments)" class="margin-lr-sm"/>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import navModular from '@/components/adminNav.vue'
    import headerModular from '@/components/headeMode'
    import pageTitle from '@/components/pageTitle'
    import {yearCheckAlert} from "@/api/projectOffice";

    export default {
        name: "index",
        components: {
            navModular,
            headerModular,
            pageTitle
        },
        data() {
            return {
                navPath: '',
                pageTitle: '',
                isBack: false,
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                let _data = await yearCheckAlert()
                if (_data.data.shen === 1) {
                    this.open(_data.data.due_date)
                }
            },
            open(date) {
                this.$confirm(`该机构将于${date}到期，以防影响您的正常使用，请及时前往机构信息页提交机构材料。`, '年审提醒', {
                    confirmButtonText: '立即前往提交',
                    cancelButtonText: '我知道了',
                }).then(() => {
                    this.$router.push('/train/info')
                }).catch(() => {
                });
            },
            getIndex(data) {
                this.navPath = data[0]
                this.pageTitle = data[1]
                this.isBack = data[2]
            },
        }
    }
</script>

<style scoped lang="scss">
    .main-warpper {
        height: calc(100vh - 80px);
        overflow-y: scroll;
    }
</style>